namespace TabAurous.HR {
    export interface EmploymentTypeForm {
        Code: Serenity.StringEditor;
        Name: Serenity.StringEditor;
    }

    export class EmploymentTypeForm extends Serenity.PrefixedContext {
        static formKey = 'HR.EmploymentType';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!EmploymentTypeForm.init)  {
                EmploymentTypeForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;

                Q.initFormType(EmploymentTypeForm, [
                    'Code', w0,
                    'Name', w0
                ]);
            }
        }
    }
}
